import { render, staticRenderFns } from "./PointCloudFileConfig.vue?vue&type=template&id=1e22e6dc&scoped=true"
import script from "./PointCloudFileConfig.vue?vue&type=script&lang=js"
export * from "./PointCloudFileConfig.vue?vue&type=script&lang=js"
import style0 from "./PointCloudFileConfig.vue?vue&type=style&index=0&id=1e22e6dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e22e6dc",
  null
  
)

export default component.exports